/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useEffect } from "react";
import { Box, FlexContainer, theme } from "@nordcloud/gnui";
import { SearchInput } from "~/components";
import { maxSearchLength, searchDelay } from "~/components/SearchInput/const";
import { useEventDetailsTab } from "~/views/events/EventsDetails/Tabs/Details/EventDetailsTabProvider";
import { ReportDownload } from "../../ReportDownload";
import { useReportState } from "../ReportProvider";
import { ReportFilters } from "./ReportFilters";

const minSearchLength = 1;

type Props = {
  eventActionId: string;
};

export function ReportHeader({ eventActionId }: Props) {
  const { updateReportState } = useReportState();
  const { resourceController } = useEventDetailsTab();
  const { resourceSearchState, updateResourceSearchState } = resourceController;

  const onChange = async (query: string) => {
    updateResourceSearchState({ searchPhrase: query, page: undefined });
  };

  useEffect(() => {
    updateReportState({ searchQuery: resourceSearchState.searchPhrase });
  }, [resourceSearchState.searchPhrase, updateReportState]);

  return (
    <Box mb={theme.spacing.spacing04}>
      <FlexContainer mb={theme.spacing.spacing04}>
        <div css={{ flex: 1, marginRight: theme.spacing.spacing04 }}>
          <SearchInput
            placeholder="Type a Keyword (e.g., Resource Name, Resource ID, Update Name, etc.)"
            value={resourceSearchState.searchPhrase ?? ""}
            onSubmit={onChange}
            onChange={onChange}
            debounceMs={searchDelay}
            minLength={minSearchLength}
            maxLength={maxSearchLength}
          />
        </div>
        <ReportDownload eventActionId={eventActionId} />
      </FlexContainer>
      <ReportFilters />
    </Box>
  );
}
